import Quill from 'quill';
import i18next from 'i18next';
import sprite from 'images/MercatelyIcons.svg';

import { getFlowToolById } from './conversationFlowTools';

const Embed = Quill.import('blots/embed');

const escapeHtml = (value = '') => String(value)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;');

const iconHref = (icon) => {
  const iconPath = sprite.startsWith('http') ? sprite : `${window.location.origin}${sprite}`;
  return `${iconPath}#${icon}`;
};

const applyRowLayout = (node) => {
  node.style.display = 'inline-flex';
  node.style.flexDirection = 'row';
  node.style.alignItems = 'center';
  node.style.whiteSpace = 'nowrap';
  node.style.verticalAlign = 'middle';
};

class ToolPillBlot extends Embed {
  constructor(node) {
    super(node);
    applyRowLayout(this.contentNode);
    this.contentNode.style.gap = '0.375rem';
  }

  static create(value) {
    const node = super.create();
    const toolId = value?.id || '';
    const index = value?.index ?? '0';
    const tool = getFlowToolById(toolId);
    const label = value?.label || (tool ? i18next.t(tool.titleKey, { ns: 'ChatbotIA' }) : toolId);
    const icon = tool?.icon || 'code';
    const bgClass = tool?.bgClass || 'tw-bg-blue-50';
    const colorClass = tool?.colorClass || 'tw-text-blue-500';

    node.setAttribute('data-tool-id', toolId);
    node.setAttribute('data-tool-index', String(index));
    node.setAttribute('contenteditable', 'false');
    applyRowLayout(node);
    node.style.width = 'fit-content';
    node.style.maxWidth = '100%';
    node.classList.add(
      'tw-bg-white',
      'tw-inline-flex',
      'tw-flex-row',
      'tw-items-center',
      'tw-gap-1.5',
      'tw-border',
      'tw-border-gray-200',
      'tw-rounded-lg',
      'tw-p-1',
      'tw-pl-1.5',
      'tw-mx-1',
      'tw-align-middle',
      'tw-select-none',
      'tw-whitespace-nowrap',
      'tw-mb-[2px]'
    );
    node.innerHTML = `<span class="tw-p-1 tw-rounded-md tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center ${bgClass}"><svg class="tw-size-[14px] ${colorClass}" fill="currentColor" style="pointer-events:none;display:block"><use href="${iconHref(icon)}"></use></svg></span><span class="tw-text-3xs tw-text-gray-500 tw-font-medium">${escapeHtml(label)}</span><span data-remove-tool-index="${index}" class="tw-ml-1 tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-gray-200 tw-text-gray-500 tw-bg-white tw-cursor-pointer"><svg class="tw-size-[12px]" fill="currentColor" style="pointer-events:none;display:block"><use href="${iconHref('close-outline')}"></use></svg></span>`;

    return node;
  }

  static value(node) {
    return {
      id: node.getAttribute('data-tool-id'),
      index: node.getAttribute('data-tool-index') || '0'
    };
  }
}

ToolPillBlot.blotName = 'toolPill';
ToolPillBlot.tagName = 'span';
ToolPillBlot.className = 'mia-tool-pill';

if (!Quill.imports['formats/toolPill']) {
  Quill.register(ToolPillBlot);
}

export const toolPillMatcher = (node) => {
  const Delta = Quill.import('delta');
  return new Delta().insert({
    toolPill: {
      id: node.getAttribute('data-tool-id'),
      index: node.getAttribute('data-tool-index') || '0'
    }
  });
};

export default ToolPillBlot;
